module.exports = {
	"version": "2.0",
	"metadata": {
		"uid": "iot-data-2015-05-28",
		"apiVersion": "2015-05-28",
		"endpointPrefix": "data.iot",
		"protocol": "rest-json",
		"serviceFullName": "AWS IoT Data Plane",
		"signatureVersion": "v4",
		"signingName": "iotdata"
	},
	"operations": {
		"DeleteThingShadow": {
			"http": {
				"method": "DELETE",
				"requestUri": "/things/{thingName}/shadow"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"payload"
				],
				"members": {
					"payload": {
						"type": "blob"
					}
				},
				"payload": "payload"
			}
		},
		"GetThingShadow": {
			"http": {
				"method": "GET",
				"requestUri": "/things/{thingName}/shadow"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"payload": {
						"type": "blob"
					}
				},
				"payload": "payload"
			}
		},
		"Publish": {
			"http": {
				"requestUri": "/topics/{topic}"
			},
			"input": {
				"type": "structure",
				"required": [
					"topic"
				],
				"members": {
					"topic": {
						"location": "uri",
						"locationName": "topic"
					},
					"qos": {
						"location": "querystring",
						"locationName": "qos",
						"type": "integer"
					},
					"payload": {
						"type": "blob"
					}
				},
				"payload": "payload"
			}
		},
		"UpdateThingShadow": {
			"http": {
				"requestUri": "/things/{thingName}/shadow"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName",
					"payload"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					},
					"payload": {
						"type": "blob"
					}
				},
				"payload": "payload"
			},
			"output": {
				"type": "structure",
				"members": {
					"payload": {
						"type": "blob"
					}
				},
				"payload": "payload"
			}
		}
	},
	"shapes": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/iot-data-2015-05-28.min.json
// module id = 426
// module chunks = 0